import React from 'react';
import { i18n_reactivate_now } from '@yi/i18n/phrases/i18n_reactivate_now';
import { i18n_start_your_free_membership_trial } from '@yi/i18n/phrases/i18n_start_your_free_membership_trial';
import { i18n_try_free_for_x_days } from '@yi/i18n/phrases/i18n_try_free_for_x_days';
import { i18n_want_to_try_this_class_today } from '@yi/i18n/phrases/i18n_want_to_try_this_class_today';

import { utilities } from '~/common';
import { useIsEligibleForFreeTrial } from '~/src/common/membership';
import { useConvertedContentFrom } from '~/src/common/sign-up/converted-content-from';
import { useLocale } from '~/src/components/LocaleProvider';

import { PaywallContentWithImage } from './PaywallContentWithImage';

export const FreeClassPaywall: React.FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const { locale } = useLocale();
  const defaultSignupPath = utilities.getLocalizedDefaultSignupPath(locale, '/billing');
  const { isEligibleForFreeTrial, loading } = useIsEligibleForFreeTrial();

  const { addToUrlConvertedContentFrom } = useConvertedContentFrom();

  const path = addToUrlConvertedContentFrom({
    returnUrl,
    targetUrl: defaultSignupPath,
  });

  return (
    <PaywallContentWithImage
      testId="article-basic-paywall-modal"
      heading={i18n_want_to_try_this_class_today(locale)}
      subHeading={i18n_start_your_free_membership_trial(locale)}
      buttonText={
        loading || isEligibleForFreeTrial
          ? i18n_try_free_for_x_days(locale, { days: '7' })
          : i18n_reactivate_now(locale)
      }
      buttonUrl={path}
      buttonLoading={loading}
      buttonDisabled={loading}
      buttonDataCampaign="basic_member_classes_paywall"
    />
  );
};
